export default function onClick(file) {
    if (this.leftbox_enabled) return this.onMoveLeft(file);
    let ext = file.split(".").pop().toLowerCase();
    if (this.isImageByExtension(ext)) return this.viewImage(file);
    return window.open("/" + this.getPath() + "/" + file, "_blank").focus();
}
